var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-container" }, [
      _c("div", { staticClass: "skeleton-box" }, [
        _c("div", { staticClass: "skeleton-image shimmer" }),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-text shimmer" }),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-text shimmer" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }